import PreferredLocationService from 'src/services/preferredLocationsService';

export const SET_PREFERRED_LOCATION_LISTS = 'SET_PREFERRED_LOCATION_LISTS';

export function setPreferredLocationLists(lists) {
  return {
    type: SET_PREFERRED_LOCATION_LISTS,
    payload: lists,
  };
}

export function fetchPreferredLocationLists() {
  return async (dispatch) => {
    try {
      const service = new PreferredLocationService();
      const res = await service.getPreferredLocationLists();

      // Check for valid response data
      if (!res?.data) {
        console.error('Error fetching preferred location lists invalid format:', res);
        // Set empty array as fallback to prevent null reference errors
        dispatch(setPreferredLocationLists([]));
      }

      dispatch(setPreferredLocationLists(res.data));
    } catch (error) {
      console.error('Error fetching preferred location lists:', error);
      // Set empty array as fallback to prevent null reference errors
      dispatch(setPreferredLocationLists([]));
    }
  };
}
